import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _041458ba = () => interopDefault(import('../../../pages/bedankt.vue' /* webpackChunkName: "pages/bedankt" */))
const _53bef6ee = () => interopDefault(import('../../../pages/betalingsgegevens.vue' /* webpackChunkName: "pages/betalingsgegevens" */))
const _cdd54ff6 = () => interopDefault(import('../../../pages/extra-opties.vue' /* webpackChunkName: "pages/extra-opties" */))
const _58a4679d = () => interopDefault(import('../../../pages/lidmaatschap.vue' /* webpackChunkName: "pages/lidmaatschap" */))
const _a702480c = () => interopDefault(import('../../../pages/persoonlijke-gegevens.vue' /* webpackChunkName: "pages/persoonlijke-gegevens" */))
const _83604c66 = () => interopDefault(import('../../../pages/ab/bedankt.vue' /* webpackChunkName: "pages/ab/bedankt" */))
const _37b05e33 = () => interopDefault(import('../../../pages/ab/betalingsgegevens.vue' /* webpackChunkName: "pages/ab/betalingsgegevens" */))
const _f48ac7ca = () => interopDefault(import('../../../pages/ab/extra-opties.vue' /* webpackChunkName: "pages/ab/extra-opties" */))
const _4549abb3 = () => interopDefault(import('../../../pages/ab/lidmaatschap.vue' /* webpackChunkName: "pages/ab/lidmaatschap" */))
const _ac545eb8 = () => interopDefault(import('../../../pages/ab/persoonlijke-gegevens.vue' /* webpackChunkName: "pages/ab/persoonlijke-gegevens" */))
const _50be0b4a = () => interopDefault(import('../../../pages/ab/club/_id.vue' /* webpackChunkName: "pages/ab/club/_id" */))
const _e68b8976 = () => interopDefault(import('../../../pages/club/_id.vue' /* webpackChunkName: "pages/club/_id" */))
const _00c82d9e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/bedankt",
    component: _041458ba,
    name: "bedankt"
  }, {
    path: "/betalingsgegevens",
    component: _53bef6ee,
    name: "betalingsgegevens"
  }, {
    path: "/extra-opties",
    component: _cdd54ff6,
    name: "extra-opties"
  }, {
    path: "/lidmaatschap",
    component: _58a4679d,
    name: "lidmaatschap"
  }, {
    path: "/persoonlijke-gegevens",
    component: _a702480c,
    name: "persoonlijke-gegevens"
  }, {
    path: "/ab/bedankt",
    component: _83604c66,
    name: "ab-bedankt"
  }, {
    path: "/ab/betalingsgegevens",
    component: _37b05e33,
    name: "ab-betalingsgegevens"
  }, {
    path: "/ab/extra-opties",
    component: _f48ac7ca,
    name: "ab-extra-opties"
  }, {
    path: "/ab/lidmaatschap",
    component: _4549abb3,
    name: "ab-lidmaatschap"
  }, {
    path: "/ab/persoonlijke-gegevens",
    component: _ac545eb8,
    name: "ab-persoonlijke-gegevens"
  }, {
    path: "/ab/club/:id?",
    component: _50be0b4a,
    name: "ab-club-id"
  }, {
    path: "/club/:id?",
    component: _e68b8976,
    name: "club-id"
  }, {
    path: "/",
    component: _00c82d9e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
